import { gql } from '@apollo/client';

export const fetchEmailDetails = gql`
  query fetchEmailDetails($email: String!) {
    fetchEmailDetails(email: $email) {
      id
      attachments {
        checksum
        contentType
        contentDisposition
        filename
        size
        id
        self
      }
      date
      html
      mailbox
      messageId
      raw
      self
      size
      subject
      text
      from {
        address
        name
      }
      to {
        address
        name
      }
      bcc {
        address
        name
      }
      cc {
        address
        name
      }
      replyTo {
        address
        name
      }
    }
  }
`;
